<template>
  <div>
    <transition name="mask">
      <div @click="closeShow" class="search-mask" v-show="show"></div>
    </transition>
    <transition name="bounce">
      <div class="search-box" v-show="show">
        <div class="search-contain item">
          <input placeholder="输入规格名称或尺寸，例如“一寸”或“413”等" v-model="keywords" @focus="inputFocus" type="text" class="search-input">
          <div @click="handleSearch" class="search-btn">搜索</div>
        </div>
        <div class="txt item">
          <div style="width: 58%;display: flex;justify-content: space-between;align-content: center">
            <div v-show="listShowFlag==='hot'" style="font-size: 16px;color: #35315C;font-weight: 600">热门规格</div>
            <div v-show="listShowFlag==='search'" style="font-size: 16px;color: #35315C;font-weight: 600">搜索结果</div>
            <div v-show="listShowFlag==='group'" style="font-size: 16px;color: #35315C;font-weight: 600">证件照分类</div>
            <div v-show="listShowFlag==='size'" style="width: 50%">
              <span @click="moreSize" style="cursor: pointer;font-size: 16px;color: #35315C;margin-right: 5%;font-weight: 600">证件照分类</span>
              <span style="font-size: 12px;color: #35315C;">{{`/ ${currentGroupInfo.group_name}`}}</span>
            </div>

            <div @click="titleClick" style="display: flex;align-items: center;cursor: pointer">
              <img v-show="listShowFlag!=='hot'" style="width: 10px" src="../assets/make/preview/back-hot-icon.png"/>
              <div style="font-size: 10px;color: #aaaaaa">{{listShowFlag==='hot'?'更多尺寸':'返回热门尺寸'}}</div>
              <img v-show="listShowFlag==='hot'" style="width: 10px" src="../assets/make/preview/search-more-icon.png"/>
            </div>
          </div>
        </div>
        <div style="" class="list item">
          <div v-show="listShowFlag!=='group'&&showSizeList.length>0" class="size-icon-list">
            <div @click="sizeClick(item)" :style="{marginTop:index>3?'1.8%':'0',marginLeft:index%4===0?'0':'1.8%',backgroundImage: 'url(' + (currentSizeInfo.spec_id===item.spec_id ? selectedBg : '')  + ')'}"
                 :key="index" v-for="(item, index) in showSizeList" :class="currentSizeInfo.spec_id===item.spec_id?'size-icon-active':'size-icon'">
              <img style="width: 32%;" :src="item.icon_url"/>
              <span class="overflow" style="font-size: 12px;color:#35315c;font-weight: 600">{{item.spec_name}}</span>
              <span style="font-size: 12px;transform: scale(0.7);color:rgba(53,49,92,0.4)">{{item.px_size}}</span>
              <span style="font-size: 12px;transform: scale(0.7);color:rgba(53,49,92,0.4);line-height: 8px">{{item.mm_size}}</span>
            </div>

            <div @click="customClick" :style="{marginTop:showSizeList.length>3?'1.8%':'0',marginLeft:showSizeList.length%4===0?'0':'1.8%',backgroundImage: 'url(' + (currentSizeInfo.spec_id===-4 ? selectedBg : '')  + ')'}"
                 :class="currentSizeInfo.spec_id===-4?'size-icon-active':'size-icon'">
              <img style="width: 32%" :src="customSizeIcon"/>
              <span class="overflow" style="font-size: 12px;color:#35315c;font-weight: 600;line-height: 25px">自定义规格</span>
              <span style="font-size: 12px;transform: scale(0.7);color:rgba(53,49,92,0.4);line-height: 8px">设置大小尺寸</span>

            </div>
          </div>
          <div class="no-search" v-show="showSizeList.length===0&&listShowFlag==='search'">
            <img style="width: 40%;margin-top:12%" src="../assets/make/rightDialog/search-no.png">
            <span style="font-size: 14px;color: #35315c">没有找到您搜索的规格</span>
            <span style="font-size: 12px;color: #35315c;opacity: 0.4;transform: scale(0.8);line-height: 30px">请输入明确的证件照规格名称进行搜索，如「美国签证」、「四级」、「国考」</span>
          </div>
          <div v-show="listShowFlag==='group'" class="size-icon-list">
            <div @click="groupClick(index,item)" :style="{marginTop:index>3?'1.8%':'0',marginLeft:index%4===0?'0':'1.8%',backgroundImage: 'url(' + (currentGroupInfo.group_name===item.group_name ? selectedBg : '')  + ')'}"
                 :key="index" v-for="(item, index) in showGroupList" :class="currentGroupInfo.group_name===item.group_name?'size-icon-active':'size-icon'">
              <img style="width: 32%" :src="item.group_pic_url"/>
              <span class="overflow" style="font-size: 12px;color:#35315c;font-weight: 600">{{item.group_name}}</span>

            </div>
            <div @click="customClick" :style="{marginTop:showGroupList.length>3?'1.8%':'0',marginLeft:showGroupList.length%4===0?'0':'1.8%',backgroundImage: 'url(' + (currentSizeInfo.spec_id===-4 ? selectedBg : '')  + ')'}"
                 :class="currentSizeInfo.spec_id===-4?'size-icon-active':'size-icon'">
              <img style="width: 32%" :src="customSizeIcon"/>
              <span class="overflow" style="font-size: 12px;color:#35315c;font-weight: 600;line-height: 25px">自定义规格</span>
              <span style="font-size: 12px;transform: scale(0.7);color:rgba(53,49,92,0.4);line-height: 8px">设置大小尺寸</span>

            </div>
          </div>
          <div v-show="!showCustom" class="size-info-contain">
            <div style="display: flex;align-items: center;padding: 5% 0">
              <div class="trapezoid"></div>
              <div style="font-size: 14px;color: #35315c">规格详情</div>
            </div>
            <div v-show="JSON.stringify(currentSizeInfo)!=='{}'">
              <div class="size-info-contain-item">
                <span class="left-txt">像素尺寸：</span>
                <span class="right-txt">{{currentSizeInfo.px_size}}</span>
              </div>
              <div class="size-info-contain-item">
                <span class="left-txt">冲印尺寸：</span>
                <span class="right-txt">{{currentSizeInfo.mm_size}}</span>
              </div>
              <div class="size-info-contain-item">
                <span class="left-txt">分辨率：</span>
                <span class="right-txt">{{currentSizeInfo.ppi}}</span>
              </div>
              <div class="size-info-contain-item">
                <span class="left-txt">文件大小：</span>
                <span class="right-txt">{{currentSizeInfo.file_size}}</span>
              </div>
              <div class="size-info-contain-item">
                <span class="left-txt">照片格式：</span>
                <span class="right-txt">{{currentSizeInfo.photo_format}}</span>
              </div>
              <div class="size-info-contain-item">
                <span class="left-txt">背景色：</span>
                <div style="display: flex">
                  <div class="color-cube" :style="{backgroundImage:item.colorValue}" :key="index" v-for="(item, index) in currentSizeInfo.background_color"></div>
                </div>
              </div>
              <div class="size-info-contain-item">
                <span class="left-txt">其他要求：</span>
                <span style="width: 70%" class="right-txt overflow">{{currentSizeInfo.face_params}}</span>
              </div>
            </div>
            <div v-show="JSON.stringify(currentSizeInfo)==='{}'" class="no-size">
              <img style="width:42%" src="../assets/make/preview/no-size-info.png"/>
              <div style="transform: scale(0.9);font-size:12px;color:#35315c">暂未选择规格</div>
            </div>
          </div>
          <CustomSizeDialog ref="custom" :show="showCustom"></CustomSizeDialog>
        </div>
        <div class="footer">
          <div @click="cancel" class="footer-btn" style="background-color: #F5F6FA;color: #35315c">取消</div>
          <div @click="handleConfirm" class="footer-btn" style="background-color: #4B00A4;color: white">确认</div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
    import api from "../makeOnlineApi/api";
    import utils from "../makeOnlineApi/utils";
    import customSizeIcon from "../assets/make/preview/custom-size-icon.png"
    import selectedBg from "../assets/make/preview/selected-bg.png"
    import CustomSizeDialog from "./CustomSizeDialog";
    export default {
        name: "SearchInput",
        props:['show'],
        components:{CustomSizeDialog},
        data(){
            return{
                customSizeIcon:customSizeIcon,
                selectedBg:selectedBg,
                showSizeList:[],
                showGroupList:[],
                hotList:[],
                listShowFlag:'hot',
                keywords:'',
                currentSizeInfo:{},
                currentGroupInfo:{},
                color:`linear-gradient(#e66465, #9198e5)`,
                showCustom:false,

            }
        },

        mounted() {

        },
        watch:{     //监听value的变化，进行相应的操作即可
            show: function(newValue){     //a是value的新值，b是旧值
              if (newValue){ // 监听打开搜索面板

                  this.hotList.length===0&&this.getHotList() // 第一次进入查询热门规格
              }
            }
        },
        methods:{
            inputFocus(){


            },
            closeShow(){
                this.$emit('close',false)
            },
            getHotList(){

                api.getHostList().then(res=>{
                    this.hotList=res.data.result;
                    this.backHotSizeUtils(this.hotList)
                    this.listShowFlag='hot' // 当前显示为规格类型分组

                })
            },
            getSizeGroup(){
                api.getSizeGroup().then(res=>{
                    this.$store.dispatch('updateSizeList',res.data.result);

                    this.showGroupList = res.data.result.map(item=>{
                        return {
                            group_pic_url:item.group_pic_url,
                            group_name:item.group_name,

                        }
                    });
                    this.listShowFlag='group' // 当前显示为规格类型分组
                })
            },
            titleClick(){
                console.log('flag',this.listShowFlag);
                if (this.listShowFlag==='hot'){
                    this.moreSize()
                }else {
                    this.backHotSize()
                }
            },
            moreSize(){
                this.showGroupList.length===0?this.getSizeGroup():this.listShowFlag='group'

            },
            backHotSize(){
                this.backHotSizeUtils(this.hotList)
                this.listShowFlag='hot'
            },
            backHotSizeUtils(hotList){
                this.showSizeList = hotList.map(item=>{
                    return {
                        spec_id:item.photo_params.spec_id,
                        icon_url:item.photo_params.icon_url,
                        spec_name:item.photo_params.spec_name,
                        px_size:`${item.photo_params.px_size[0]} x ${item.photo_params.px_size[1]} px`,
                        mm_size:`${item.photo_params.mm_size[0]} x ${item.photo_params.mm_size[1]} mm`,
                        ppi:`${item.photo_params.ppi}dpi`,
                        file_size:utils.getFileSize(item.photo_params.file_size),
                        photo_format:item.photo_params.format,
                        background_color:utils.colorToLinearGradient(item.photo_params.background_color),
                        face_params:item.photo_params.face_params?item.photo_params.face_params.toString():
                            '无噪声,不模糊,服装突出,肩膀等高，中性表情，双眼水平，人像居中，正面(人脸姿态自然)',
                    }
                });
            },
            // 点击规格分组
            groupClick(index,item){
                this.currentGroupInfo=item;
                let sizeList = this.$store.state.sizeList[index].specs_info;
                let icon_url = this.$store.state.sizeList[index].group_pic_url;
                console.log('sizeList',sizeList);
                this.showSizeList = sizeList&&sizeList.map(item=>{
                    return {
                        spec_id:item.spec_id,
                        icon_url:icon_url,
                        spec_name:item.spec_name,
                        px_size:`${item.px_size[0]} x ${item.px_size[1]} px`,
                        mm_size:`${item.mm_size[0]} x ${item.mm_size[1]} mm`,
                        ppi:`${item.ppi}dpi`,
                        file_size:utils.getFileSize(item.file_size),
                        photo_format:item.photo_format,
                        background_color:utils.colorToLinearGradient(item.background_color),
                        face_params:item.face_params?item.face_params.toString():
                            '无噪声,不模糊,服装突出,肩膀等高，中性表情，双眼水平，人像居中，正面(人脸姿态自然)',
                    }
                });
                this.listShowFlag='size' // 当前显示为单个规格
            },

            // 点击尺寸
            sizeClick(item){
                this.currentSizeInfo=item;
                console.log('currentSizeInfo',this.currentSizeInfo.background_color[0].colorValue)
                this.showCustom=false
            },
            // 点击自定义规格
            customClick(){
                this.currentSizeInfo={spec_name:'自定义规格',spec_id:-4};
                this.showCustom=true
            },

            handleSearch(){
                if(this.keywords!=='') {
                    let finalKeywords = '';
                    if (this.keywords !== '%') {
                        finalKeywords = this.keywords.split('%').join('');
                        if (finalKeywords === '') {
                            finalKeywords = '%'   // 如果是多个%择保留一个%
                        }
                    }
                    api.searchSize(finalKeywords).then((res)=>{
                        console.log('查询结果',res.data.result);
                        console.log('查询结果长度',res.data.result.length);
                        let sizeList=[]
                        res.data.result.forEach(item=>{
                            let icon_url=item.group_pic_url
                            item.specs_info.forEach(itemChild=>{
                                sizeList.push({
                                    ...itemChild,
                                    icon_url,
                                })
                            })

                        });

                        console.log('sizeList',sizeList);
                        this.showSizeList = sizeList&&sizeList.map(item=>{
                            return {
                                spec_id:item.spec_id,
                                icon_url:item.icon_url,
                                spec_name:item.spec_name,
                                px_size:`${item.px_size[0]} x ${item.px_size[1]} px`,
                                mm_size:`${item.mm_size[0]} x ${item.mm_size[1]} mm`,
                                ppi:`${item.ppi}dpi`,
                                file_size:utils.getFileSize(item.file_size),
                                photo_format:item.photo_format,
                                background_color:utils.colorToLinearGradient(item.background_color),
                                face_params:item.face_params?item.face_params.toString():
                                    '无噪声,不模糊,服装突出,肩膀等高，中性表情，双眼水平，人像居中，正面(人脸姿态自然)',
                            }
                        });
                        this.listShowFlag='search'

                    })
                }

            },

            handleConfirm(){
                let customRef = this.$refs.custom
                if (this.currentSizeInfo.spec_id===this.$store.state.sizeInfo.spec_id){
                    // 未改变规格 不需要制作操作 只要关闭
                    this.$emit('close',false)
                    return
                }
                if (this.currentSizeInfo.spec_id===-4){
                    this.customConfirm(customRef)
                }else{
                    this.commonConfirm()
                }


            },
            commonConfirm(){
                // this.$store.dispatch('updateSizeInfo',this.currentSizeInfo)
                this.$emit('confirm',{sizeInfo:this.currentSizeInfo})
                this.$emit('close',false)
            },
            customConfirm(customRef){
                const aspectRatio= Number(customRef.sizeWidth)/Number(customRef.sizeHeight)
                console.log(customRef)
                console.log('aspectRatio',aspectRatio)
                if (customRef.sizeWidth===''||customRef.sizeHeight==='') {
                    //

                    this.$message.warning({
                        showClose: true,
                        message:'图像宽度和高度不能为空！'
                    })
                }else if ((Number(customRef.sizeWidth)<10||Number(customRef.sizeWidth)>3000)||(Number(customRef.sizeHeight)<10||Number(customRef.sizeHeight)>3000)) {
                    //
                    this.$message.warning({
                        showClose: true,
                        message:'图像宽度不能小于10px,高度不能大于3000 px,请重新输入图像宽高!!'
                    })

                }else if (aspectRatio<=0.56||aspectRatio>=1) {
                    //
                    this.$message.warning({
                        showClose: true,
                        message:'宽高比需要在0.56到1之间！'
                    })

                }else if ((customRef.sizeMin!==''&&customRef.sizeMax!=='')&&((Number(customRef.sizeMin)<1||Number(customRef.sizeMin)>2048)||(Number(customRef.sizeMax)<1||Number(customRef.sizeMax)>2048))) {
                    //
                    this.$message.warning({
                        showClose: true,
                        message:'输入的文件大小最小值不能小于1KB,最大值不能大于2048KB,请重新输入图像文件大小'
                    })

                }else if ((customRef.sizeMin!==''&&customRef.sizeMax!=='')&&(Number(customRef.sizeMax)<Number(customRef.sizeMin))) {
                    //
                    this.$message.warning({
                        showClose: true,
                        message:'输入的文件大小最大值不可小于最小值,请重新输入图像文件大小'
                    })

                }else{
                    // 通过校验
                    let getBackgroundColor=()=>{
                        return new Promise((resolve)=>{
                            api.getCustomBgColor().then(res=>{
                                resolve(res.data)
                            })
                        })
                    }
                    let getExtraSpec=()=>{
                        return new Promise((resolve)=>{
                            api.getCustomExtraSpec().then(res=>{
                                resolve(res.data)
                            })
                        })
                    }
                    Promise.all([getBackgroundColor(),getExtraSpec()]).then(result=>{
                        console.log('背景色，优惠服务',result)
                        let customSizeData={
                            file_size:[customRef.sizeMin===''?'':Number(customRef.sizeMin)*1024,customRef.sizeMax===''?'':Number(customRef.sizeMax)*1024],
                            dpi:customRef.dpi?Number(customRef.dpi):300,
                            photo_format:'jpg',
                            custom_size:[customRef.sizeWidth===''?10:Number(customRef.sizeWidth),customRef.sizeHeight===''?3000:Number(customRef.sizeHeight)],
                            background_color:result[0].colors,
                            extra_spec_info:result[1].url,
                            spec_name:'自定义规格',
                            spec_id:-4
                        }
                        console.log('自定义规格参数',customSizeData)
                        this.currentSizeInfo=customSizeData
                        // this.$store.dispatch('updateSizeInfo',{...customSizeData})
                        this.$emit('confirm',{sizeInfo:customSizeData})
                        this.$emit('close',false)
                    })


                }
            },
            cancel(){
                this.$emit('close',false)
            },

        }
    }
</script>

<style scoped>
  .search-box{
    width: 62%;height: 70%;background-color: #FFFFFF  ;
    position: absolute;
    z-index: 15;
    top: 10%;
    left: 15%;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;


  }
  .search-mask{
    width: 100%;height: 100%;background-color: rgba(0,0,0,0.4)  ;
    position: absolute;
    z-index: 14;
    transform: translateY(-10%);

  }
  .item{
    width: 87%;
  }

  .search-contain{

    height: 40px;
    display: flex;
    margin: 10px 0;
  }
  .search-input{
    width: 90%;
    height: 40px;

    outline:none;
    color: #35315c;
    border: 1px solid #FF7BAC;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-image: url(../assets/make/preview/search-icon.png);/*设置小图标*/

    background-size: 20px 20px;/*小图标的大小*/

    background-position: 2% 45%;/*小图标在input的位置*/

    background-repeat: no-repeat;/*背景小图标不重复*/

    padding: 0 4% 0 40px;/*设置input内边距*/
  }
  .search-input:focus{

  }

  .search-btn{
    background-color: #FF7BAC;
    width: 10%;
    height: 42px;
    color: #FFFFFF;
    font-size: 18px;
    text-align: center;
    line-height: 42px;
    cursor: pointer;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .no-search{
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .txt{
    height: 40px;
    display: flex;
    align-items: center;
  }
  .list{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 56%;
  }
  .size-icon-list{
    width: 59%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    overflow-y:auto ;
  }
  .size-icon{
    width: 22.2%;
    height: 29.5%;
    border:1px solid rgba(53,49,92,0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .size-icon-active{
    width: 22.2%;
    height: 29.5%;
    border:1px solid #FF7BAC;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    background-size: 100% 100%;

  }
  .size-info-contain{
    width: 35%;
    height: 100%;
    background-color: #F5F6FA;
    border-radius: 4px;
  }
  .size-info-contain-item{
    width: 86%;
    padding:0 7% 7% 7%;
    justify-content: space-between;
    display: flex;

  }
  .size-info-contain-item>span{
    font-size: 12px;
    transform: scale(0.9);
  }
  .size-info-contain-item>.left-txt{
    color: rgba(53,49,92,0.4);
  }
  .size-info-contain-item>.right-txt{
    color: #35315C;
  }
  .bounce-enter-active {
    animation: bounce-in 0.5s;
  }
  .bounce-leave-active {
    animation: bounce-in 0.5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: translateY(-100%);
    }

    100% {
      transform: translateY(0px);
    }
  }
  .mask-enter-active {
    animation: mask-in 0.5s;
  }
  .mask-leave-active {
    animation: mask-in 0.5s reverse;
  }
  @keyframes mask-in {
    0% {
      background-color: rgba(0,0,0,0.0);
    }

    100% {
      background-color: rgba(0,0,0,0.4);
    }
  }
  .overflow{
    width: 90%;
    white-space:nowrap;
    text-overflow:ellipsis;
    overflow:hidden;
    text-align: center;
  }

  .trapezoid{
    width:10px;
    height:10px;
    background-color:rgba(0,0,0,0);
    border-top:4px solid rgba(0,0,0,0);
    border-right:4px solid rgba(0,0,0,0);
    border-bottom:4px solid rgba(0,0,0,0);
    border-left:4px solid #FF7BAC;
  }
  .color-cube{
    width: 10px;
    height: 10px;
    margin: 0 2px;
  }
  .footer{
    width: 90%;
    height: 16%;
    margin-top: 4%;
    border-top:1px solid rgba(53,49,92,0.4);
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .footer-btn{
    width: 18%;
    height: 50%;
    margin-left: 3%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 19px;
    cursor: pointer;
  }
  .no-size{
    padding: 10% 0;width: 100%;height: 40%;display: flex;flex-direction: column;align-items: center;justify-content: space-between
  }


</style>
